import { useQuery } from "@tanstack/react-query";

import { fetchAlerts } from "@app/services/alerts";

export const useAlerts = () => {
  return useQuery({
    queryKey: ["alerts"],
    queryFn: async ({ signal }) => {
      try {
        return await fetchAlerts({ signal });
      } catch (error) {
        return [];
      }
    },
    refetchInterval: 1800000, // Refetch every 30 minutes
    refetchOnWindowFocus: true, // Refetch when the window regains focus
    staleTime: 0, // Consider data stale immediately
    gcTime: 5 * 60 * 1000, // Garbage collect data after 5 minutes
  });
};
